module.exports = __webpack_public_path__ + "img/info9.93029836.png";